import { useQueryContextStore } from '@annunciate/core';
const { setEndpoint } = useQueryContextStore.getState();
export const QueryContextProvider = ({ children, endpoint, }) => {
    setEndpoint(endpoint);
    return children;
};
//# sourceMappingURL=QueryContextProvider.js.map